import React , {Component} from 'react';
import Footer from "./div/Footer";
import headphoneIcon from './../assets/images/icons/headphone.svg';
import callIcon from './../assets/images/icons/call.svg';
import questionIcon from './../assets/images/icons/question.svg';
import arrowLeftIcon from './../assets/images/icons/arrow-left-2.svg';
import instagramIcon from './../assets/images/icons/instagram.svg';
import chatIcon from './../assets/images/icons/chat.svg';
import chat2Icon from './../assets/images/icons/chat-2.svg';
import shahraraIcon from './../assets/images/icons/shahrara.svg';
import { Modal } from 'react-bootstrap';
import * as axios from "axios/index";
import * as vars from './Vars';
import validator from "validator";

class Contact extends Component{

    constructor(props){

        super(props)
        this.state = {

            inPageLoading : false ,
            errors : {} ,
            fields : {
                body : "" ,
            } ,
            messageError : null ,
            messageModal : false ,
            branchContactInfoModalShow : false ,
            contactBranchesDetails : [] ,
        }
    }


    componentDidMount(){
        let contactBranchesDetails = JSON.parse(localStorage.getItem("contactBranchesDetails"))
        console.log(contactBranchesDetails)
        this.setState({
            contactBranchesDetails:contactBranchesDetails
        })
    }
    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }

    messageModalHideHandler(){
        this.setState({
            messageModal : false
        })
    }

    messageModalSubmitHandler(){
        let { fields } = this.state
        let errors = {}
        let formValid = true

        if ( fields.body === null || validator.isEmpty(fields.body))
        {
            formValid = false;
            errors['body'] = 'متن پیام خود را وارد کنید';
        }
        else if(! validator.isLength(fields.body , { min : 5}))
        {
            formValid = false;
            errors['body'] = 'متن پیام باید 5 حرف باشد';
        }

        if (formValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }


        this.setState({
            inPageLoading : true
        })

        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        data.append('body' , this.state.fields.body )

        axios.post(vars.Url +'api/v1/message/store' , data , {
            params : {
            }

        } )
            .then((response) => {
                let data = response.data.data
                // console.log(data)


                this.setState({
                    inPageLoading : false ,
                    messageModal : false ,
                    fields : {
                        body : "" ,
                    } ,
                })
            })
            .catch( (error) => {
                let data = error.response.data.data
                this.setState({
                    inPageLoading : false ,
                    messageError : data.message ,
                })
            })


    }


    branchContactInfoModalShowHandler(){
        this.setState({
            branchContactInfoModalShow : false ,
        })
    }

    render(){
        const {errors} = this.state
        return(

            <div id="main-custom-1" className="text-decoration-none">


                <Modal
                    show={this.state.branchContactInfoModalShow}
                    onHide={this.branchContactInfoModalShowHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>
                    <Modal.Header>
                        تماس با ما
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mt-3">
                            {this.state.contactBranchesDetails.map((object , index) =>

                                    <a href={"tel:" + (object.phone)}
                                       key={index} className=" text-decoration-none justify-content-between border-bottom pb-3 mb-3  d-block details-custom-2">
                                        <div className="row">
                                            <div className="col-11">
                                                <div className="content-custom-1">
                                                    <div className="row">
                                                        <div className="col-auto pl-0">
                                                            <img src={headphoneIcon} alt="call" className="ml-2"/>
                                                        </div>
                                                        <div className="col-auto">
                                                            {object.title}

                                                            <span className="pr-2 d-inline-block">
                                                                {object.phone}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </a>
                            )}

                        </div>
                    </Modal.Body>
                </Modal>


                <div id="in-page-loading" className={(this.state.inPageLoading === true ? "show" : "")}>
                    <div className="content-container">
                        <div className="text-center mb-3">
                            <i className="fas fa-circle-notch fa-spin item-icon"></i>
                        </div>
                        <div className="title">
                            لطفا شکیبا باشید
                        </div>
                    </div>
                </div>

                <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <span className="title">
                                                تماس با ما
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">


                            <div className="items-container items-container-custom-1">

                                <a onClick={()=>this.setState({branchContactInfoModalShow:true})} className="details-custom-2 pt-4 pb-4 d-block">
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={headphoneIcon} alt="contact"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="title">
                                                        مشکلی دارید؟
                                                    </div>
                                                    <div className="sub-title">
                                                        پشتیبانی تلفنی
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <div className="btn btn-custom-2 pb-2 pt-2">
                                                <img src={callIcon} alt="call" className="ml-2"/>
                                                تماس
                                            </div>
                                        </div>
                                    </div>

                                </a>

                                <div className="divider-custom-1 " />


                                <a href={localStorage.getItem("contactInfo_aboutUsUrl")} target="_blank" className="details-custom-2 pt-4 pb-4  d-block">
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={questionIcon} alt="contact"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="title">
                                                        از ما بیشتر بدانید
                                                    </div>
                                                    <div className="sub-title">
                                                        درباره بانان
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={arrowLeftIcon} alt="arrow-left" />
                                        </div>
                                    </div>
                                </a>

                                <a href={"https://instagram.com/" + (localStorage.getItem("contactInfo_instagramAccount"))} target="_blank" className="details-custom-2 pt-4 pb-4  d-block">
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={instagramIcon} alt="instagram"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="title">
                                                        ما را دنبال کند
                                                    </div>
                                                    <div className="sub-title">
                                                        اینستاگرام
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={arrowLeftIcon} alt="arrow-left" />
                                        </div>
                                    </div>
                                </a>

                                <div className="divider-custom-1 " />


                                <div className="details-custom-2 pt-4 pb-4  d-block" onClick={() => this.setState({messageModal : true})}>
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={chatIcon} alt="chat"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="sub-title">
                                                        ارسال پیام
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={arrowLeftIcon} alt="arrow-left" />
                                        </div>
                                    </div>
                                </div>


                                <div className="text-center mt-5 pt-5">
                                    <a href="http://shahrara.net" target="_blank">
                                        <img src={shahraraIcon} alt="shahrara"/>
                                    </a>
                                </div>


                            </div>


                        </div>
                    </div>
                </div>


                <Modal
                    show={this.state.messageModal}
                    onHide={this.messageModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            ارسال پیام
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                خوشحال می شویم تا نظر، پیشنهاد و انتقادتان از بانان را برایمان بفرستید تا بتوانیم کیفیت خدماتمان را با نظراتتان ارتقاء دهیم.
                                <br />
                            </div>
                        </div>
                        <div>
                            {
                                this.state.messageError !== null ?
                                    (
                                        <div className="alert alert-danger mt-2">
                                            {this.state.messageError}
                                        </div>
                                    )
                                    :
                                    (``)
                            }
                        </div>
                        <div  className="mt-3">
                            <div className="form-group form-group-custom-1">
                               <textarea
                                   placeholder="پیام شما"
                                   name="body"
                                   className={["form-control form-control-custom-1" , errors['body'] ? 'is-invalid' : ''].join(' ')}
                                   onChange={this.handleChange.bind(this)}
                                   value={this.state.fields.body}
                                   rows={3}
                                />
                                <span className={["invalid-feedback" ,  errors['discount_code'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['discount_code'] }</span>

                                <img src={chat2Icon} alt="chat" className="item-icon" />
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.messageModalSubmitHandler.bind(this)}>
                                ارسال
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Footer page="contact"/>
            </div>
        )
    }
}
export default Contact;